<section class="d-flex justify-content-end">
    <mat-button-toggle-group
        name="semester"
        aria-label="Semester"
        multiple
        (change)="semesterChange()"
        [(ngModel)]="kodSemester"
    >
        <mat-button-toggle value="Z">
            <span class="d-none d-md-inline" i18n>Zimný semester</span>
            <span class="d-inline d-md-none" i18n>ZS</span>
        </mat-button-toggle>
        <mat-button-toggle value="L">
            <span class="d-none d-md-inline" i18n>Letný semester</span>
            <span class="d-inline d-md-none" i18n>LS</span>
        </mat-button-toggle>
    </mat-button-toggle-group>
</section>
